import { merge, map, delay, switchMap, takeUntil, of } from 'rxjs';
import { convertToBehaviorSubject } from './convert-to-subject';
export function temporaryToggle(trigger$, duration) {
  return convertToBehaviorSubject(false)(merge(trigger$.pipe(map(() => true)), trigger$.pipe(
  // delay reset for specified duration.
  // abort reset in case there was a re-trigger in the meantime.
  switchMap(() => {
    return of(true).pipe(delay(duration), takeUntil(trigger$));
  }), map(() => false))));
}